import psHttp from '@patsnap/common-ps-http';
import { labServiceApiUrlPrefix } from '../../config/constants';
import { get } from 'lodash';

/**
 * 获取开启状态
 */
export function getUsedByAnchorApi({
    anchor
}) {
    return psHttp({
        url: `${labServiceApiUrlPrefix}/apps/app/usedByAnchor?anchor=${anchor}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return Boolean(get(data, 'data.used'));
    });
}

/**
 * 埋点
 */
export function logAnchorApi({
    anchor, action, otherAttrPlanObject = {}
}) {
    return psHttp({
        url: `${labServiceApiUrlPrefix}/apps/app/log?anchor_id=${anchor}`,
        method: 'POST',
        data: {
            action, // action=init 为保留字段
            ...otherAttrPlanObject, // 必须是 key-value简单对
        },
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}

/**
 * 批量获取开启状态
 */
export function getBatchUsedByAnchorApi({
    anchors = []
}) {
    return psHttp({
        url: `${labServiceApiUrlPrefix}/apps/app/usedByAnchor`,
        method: 'POST',
        transformCode: true,
        data: {
            anchors
        },
    }).then(({ data }) => {
        return get(data, 'data');
    });
}
